import styled from 'styled-components';
import { useState } from 'react';
import { useRouter } from 'next/router';
// components
import BothHeader from 'components/layout/headers/Both';
import OutlineButton from 'cds/buttons/Outline';
import FillButton from 'cds/buttons/Fill';
import IconButton from 'cds/buttons/Icon';
import Icon from 'cds/icons';
import MainLayout from 'cds/layout/Main';
import VerticalScrollLayout from 'cds/layout/VerticalScroll';
import Layout from 'components/layout';
// hooks
import useMetaData from 'hooks/common/useMetaData';
import useCommonBridge from 'hooks/bridge/useCommonBridge';
// styles
import { mediaQuery, palette } from 'cds/styles';
import * as typography from 'cds/typography';
import internal from 'stream';

/** FAQ 모음집 */
const faq = {
  information: [
    {
      q: 'PC로 수강할 수 있나요?',
      a: () => (
        <OrderedList style={{ listStyle: 'none' }}>
          <strong>
            결제한 계정으로 동일하게 로그인해주시면 다른 기기에서도 이용하실 수 있습니다!
          </strong>
          <br />
          <br />
          {/* <OrderedList style={{ marginTop: '15px', listStyle: 'none' }}> */}
          <strong>web</strong>
          <br />
          ☞ &nbsp;홈페이지 우측 상단 [로그인] 버튼 클릭 후 결제한 계정으로 접속!
          <br />
          <br />
          <strong>app</strong>
          <br />
          ☞ &nbsp;설치 후 로그인화면에서 결제한 계정으로 시작하기!
          <br />
          <br />- 결제한 계정이 기억나지 않거나, 로그인이 불가한 상태라면 고객센터로 문의바랍니다.
          {/* </OrderedList> */}
        </OrderedList>
      ),
    },
    {
      q: '장학금 제도가 무엇인가요?',
      a: () => (
        <OrderedList style={{ listStyle: 'none' }}>
          <OrderedList style={{ listStyle: 'none' }}>
            <strong>[미션 수행 시 장학금 지급!]</strong>
            <br />
            <br />
            미션 완료시 적립금이 지급됩니다🎁
            <br />
            지급된 적립금은 클래스유 앱 또는 웹 우측 상단{' '}
            <strong>마이프로필 &gt; 내정보 &gt; 적립금(원)</strong> 에서 확인할 수 있어요~!
            <br />
            <br />
            <strong>지급 금액</strong>
            <br />
            <br />
            미션을 모두 진행할 경우 결제금액의 약 10% 획득 가능!
            <br />
            (실결제금액×10% / 미션수(미션 진행 당시 기준) = 미션 1회 진행시 획득 가능한 포인트)
            <br />
            <br />
            <br />
            <strong>참고해주세요!</strong>
            <br />
            <br />
            -미션 재인증을 통해 미션을 다시 진행할 수 있으나 적립금은 중복으로 지급되지 않습니다.
            <br />
            -포인트 지급액은 미션이 추가되거나 제거될 경우 변동이 있을 수 있습니다.
            <br />
            -평생권은 6개월까지만 장학혜택이 제공됩니다.
          </OrderedList>
        </OrderedList>
      ),
    },
    {
      q: '미션인증은 어떻게 하나요?',
      a: () => (
        <OrderedList style={{ listStyle: 'none' }}>
          <strong>[app]</strong>
          <ol>
            <li> 휴대폰에서 '클래스유'어플을 실행해주세요!</li>
            <li> 앱 하단 '내 강좌'에서 수강중인 클래스를 클릭합니다.</li>
            <li> 앱 우측 하단 [미션인증하기] 버튼을 클릭해주세요.</li>
            <li>
              {' '}
              상단에 미션 내용 확인 후 사진과 내용을 입력하고 '오늘도 나는 해냈다!' 버튼을 클릭하면
              끝!
            </li>
          </ol>
          <br />
          <br />
          <strong>[web]</strong>
          <ol>
            <li> 클래스유 홈페이지에 접속하여 로그인해주세요!</li>
            <li>홈페이지 첫 화면 상단 또는 좌측에 수강중인 클래스를 클릭합니다.</li>
            <li>강의 재생화면 우측 하단 [미션인증하기] 버튼을 클릭해주세요.</li>
            <li>
              상단의 미션 내용 확인 후 사진과 내용을 입력하고 '오늘도 나는 해냈다!' 버튼을 클릭하면
              끝!
            </li>
          </ol>
          <br />
          <br />
          미션 진행 시 적립금이 지급됩니다! 클래스를 수강 중이시라면 꼭 미션 인증을 해주세요~!
          <br />
          미션이 없을 경우 [미션 없음]으로 표기됩니다.
        </OrderedList>
      ),
    },
    {
      q: '수업은 어떻게 진행되나요?',
      a: () => (
        <OrderedList style={{ listStyle: 'none' }}>
          모든 클래스는 녹화본 형태의 온라인 강의로 진행되어 구매하신 수강 기간 내 편한 시간대에
          <br />
          자유롭게 청취 가능, 반복 청취 가능, 하루 동안에도 전 강의 시청 가능합니다!
          <br />
          <br />
          개강 전 클래스 외 모든 클래스는 결제 후 즉시 이용하실 수 있으며,
          <br />
          <strong>{`결제하신 고객님의 경우, '마이프로필 > 내정보 > 결제내역'에서 수강 기간 확인 가능합니다.`}</strong>
          <br />
          <br />
          대부분의 클래스는 ot, 1강 무료 제공되고 있으며 강의 화면 하단의 커리큘럼 터치 시 내용 확인
          가능합니다.
          <br />
          해당 부분 참고하여 이용해 주시기 바랍니다.
          <br />
          <br />
          <u>
            # 추가 강의 업로드는 강사님 재량에 따라 상이하오니 현재 커리큘럼 기준으로 확인 후 구매
            바랍니다. #
          </u>
        </OrderedList>
      ),
    },
    {
      q: '클래스 준비물은 어떻게 구매하나요? / 배송일자는 어떻게 되나요?',
      a: () => (
        <OrderedList style={{ listStyle: 'none' }}>
          {`클래스 준비물이 있는 클래스의 경우 내강좌 > 강의 목록 하단  [멤버]에 접속 후 상단의 [준비물 구매하기]탭을 누르시면 구매 페이지로 이동합니다.`}
          <br />
          (준비물 준비기간 기본 3일 추가 제공되고 있습니다.)
          <br />
          <br />
          <strong style={{ color: palette.red040 }}>&lt;참고해주세요&gt;</strong>
          <br />
          -준비물을 구매하지 않아도 강의 시청은 가능합니다.
          <br />
          -준비물은 선택사항으로, 필요시 별도 구매해주셔야하며 타사이트에서 구매하시거나 대체 가능
          한 상품으로 이용하셔도 무방한 점 참고바랍니다.
          <br />
          <br />
          <strong>**배송일정**</strong>
          <br />- 평일 오전 11시 이전 결제 건에 대하여 준비물이 당일 출고됩니다.
          <br />
          -11시 이후 결제하신 건에 대한 준비물은 익일 출고되며, 금요일 11시이후와 주말에 결제하신
          준비물은 평일 영업일에 출고됩니다.
          <br />
          출고 후 지역에 따라 1~2일의 기간이 소요됩니다.
          <br />
          <br />
          <u>* 송장번호는 고객센터를 통해 문의주시면 안내해드리겠습니다.</u>
        </OrderedList>
      ),
    },
    {
      q: '클래스를 잠시 정지하고 싶어요.',
      a: () => (
        <OrderedList style={{ listStyle: 'none' }}>
          모든 클래스는 구매하신 수강기간동안만 이용이 가능하여 정지는 불가능합니다...😢
          <br />
          환불 규정을 확인하셔서 환불 진행해주시고, 다시 재수강이 가능하실 때 클래스유를 찾아와
          주세요~!
        </OrderedList>
      ),
    },
    {
      q: 'TV로 시청하고 싶어요!',
      a: () => (
        <OrderedList style={{ listStyle: 'none' }}>
          아쉽게도 현재는 당사에서 직접 제공하고 있는 TV 연결 프로그램이 없습니다.
          <br />
          번거로우시겠지만 PC와 직접 연결하는 형태로 이용하시거나, TV에서 웹사이트 접속이
          가능하시다면 당사 홈페이지로 접속 후 이용해주시면 됩니다.
          <br />이 외의 별도의 방법은 직접 모색해주셔야 합니다.
          <br />
          <br />
          <strong>
            (일부 기기에서 이용 제한이 있을 수 있으니, 무료로 제공되는 강의 및 OT를 통해 확인 후
            이용 부탁드립니다!)
          </strong>
        </OrderedList>
      ),
    },
    {
      q: '알림을 끄고 싶어요!',
      a: () => (
        <OrderedList style={{ listStyle: 'none' }}>
          계속되는 알림으로 번거로우신가요?
          <br />
          아래와 같은 방법으로 진행하시면 알림을 잠시 꺼두실 수 있습니다~!
          <br />
          <br />
          <strong>푸쉬알림 끄는 방법</strong>
          <br />
          {`앱 우측 상단 '마이프로필 > 내정보 > 알림관리'에서 off 로 설정`}
          <br />
          또는
          <br />
          {`휴대폰 설정 > 어플리케이션 관리 OR 알림 관리 > 클래스유 > 푸쉬 알림 끄기`}
          <br />
          <br />
          <strong>&lt;알람설정 끄는 방법 &gt;</strong>
          <br />
          내강좌 &gt; 상단 [알람 설정하기] &gt; off 후 저장
        </OrderedList>
      ),
    },
    {
      q: '클래스를 개설하고 싶어요!',
      a: () => (
        <OrderedList style={{ listStyle: 'none' }}>
          사람들과 공유하고 싶은 재능이나 노하우가 있으신가요?
          <br />
          그렇다면 누구나 클래스를 개설할 수 있습니다.
          <br />
          <br />
          앱을 열어 우측 하단 '+' 버튼을 눌러 지금 바로 클래스 개설을 신청해 보세요.
          <br />
          클래스 개설 비지니스 매니저가 함께 클래스 개설을 기획하고 진행을 도와드립니다.
        </OrderedList>
      ),
    },
    {
      q: '기업/ 단체 교육 문의하고 싶어요.',
      a: () => (
        <OrderedList style={{ listStyle: 'none' }}>
          <ol>
            <li>기업 / 단체의 경우, 원하는 니즈에 따라 커스텀화 된 제안이 가능합니다.</li>
            <li>
              원하는 목적, 니즈에 따라 2,000개의 클래스에서 담당 매니저가 큐레이션을 진행합니다.
            </li>
            <li>
              담당자분들이 구성원들의 내역을 실시간으로 볼 수 있는 솔루션을 제공합니다.
              <br />
              (인원 규모에 따라 실시간 관리가 아닌, 월간 리포트로 대체됩니다.)
            </li>
          </ol>
          <br />
          <br />
          자세한 상담을 희망하시는 경우
          <br />
          <strong>sk@classu.co.kr</strong>으로 메일 남겨주시면 빠르게 담당자가 연락 드릴 수 있도록
          하겠습니다😊
        </OrderedList>
      ),
    },
    {
      q: '강사님에게 질문이 있어요!',
      a: () => (
        <OrderedList style={{ listStyle: 'none' }}>
          클래스 내용 관련 구체적 사항, 준비물, 수업자료 관련하여 문의하시는 경우라면
          <br />
          강사님에게 문의하여 보다 상세하게 답변 받아보실 수 있습니다~!
          <br />
          <br />
          1. 강사님 프로필 누르고 팔로우 후 1:1 문의하기
          <br />
          <br />
          OR
          <br />
          <br />
          2. (구매 후) 강좌 화면 하단의 '댓글 남기기' 버튼 누르고 질문하기 버튼을 활성화 하신 후
          <br />
          질문 사항 남겨주시면 답변받아보실 수 있습니다.
          <br />
          <br />
          다만, 보다 클래스를 재밌게 즐기고
          <br />
          강사와 회원님간의 원활한 소통을 위해
          <br />
          '1:1 메세지', '질문' 하기 기능 등으로
          <br />
          최대한 피드백 해주실 것 권장드리고 있습니다만
          <br />
          <br />
          필수 의무사항은 아니기 때문에
          <br />
          강사님 개인사정에 따라 답변이 지연되거나 없을 수도 있습니다.
          <br />
          <br />
          대부분의 경우에는 가능한 열심히
          <br />
          피드백을 해주시고 계시지만
          <br />
          강사님마다 피드백률이 상이할 수 있다는 점 참고 부탁 드리며,
          <br />
          <br />
          답변이 지연되어 고객센터로 문의주시면
          <br />
          빠른 피드백 진행될 수 있도록 독려할 수 있도록 하겠습니다.
        </OrderedList>
      ),
    },
    {
      q: '로그아웃 하고 싶어요.',
      a: () => (
        <OrderedList style={{ listStyle: 'none' }}>
          클래스유 앱 또는 웹 우측 상단 &nbsp;
          <strong>마이프로필 &gt; 내정보 &gt; 하단의 [로그아웃]버튼</strong>을 눌러주시면 됩니다!
        </OrderedList>
      ),
    },
  ],
  payment: [
    {
      q: '환불하고 싶어요.',
      a: () => (
        <>
          <p style={{ padding: '20px 0 20px', fontSize: '20px' }}>수강권 환불</p>

          <table
            style={{
              width: '100%',
              border: '1px solid #dadbdc',
              borderCollapse: 'collapse',
              fontSize: '14px',
              textAlign: 'center',
            }}
          >
            <caption
              style={{
                marginBottom: '12px',
                color: '#000',
                fontWeight: 'bold',
                fontSize: '14px',
                textAlign: 'left',
              }}
            >
              수강권 환불 규정
            </caption>
            <thead>
              <tr
                style={{ padding: '10px', border: '1px solid #dadbdc', backgroundColor: '#efefef' }}
              >
                <th style={{ padding: '10px', border: '1px solid #dadbdc', textAlign: 'center' }}>
                  구분
                </th>
                <th style={{ padding: '10px', border: '1px solid #dadbdc', textAlign: 'center' }}>
                  환불액
                </th>
                <th style={{ padding: '10px', border: '1px solid #dadbdc', textAlign: 'center' }}>
                  위약금
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ padding: '10px', border: '1px solid #dadbdc' }}>
                <td
                  style={{
                    padding: '10px',
                    border: '1px solid #dadbdc',
                    backgroundColor: '#efefef',
                  }}
                >
                  수강기간 시작일로부터 7일 이내 무료로 오픈된 컨텐츠만을 이용한 경우
                </td>
                <td style={{ padding: '10px', border: '1px solid #dadbdc' }}> 결제대금 전액 </td>
                <td style={{ padding: '10px', border: '1px solid #dadbdc' }}>없음</td>
              </tr>
              <tr style={{ padding: '10px', border: '1px solid #dadbdc' }}>
                <td
                  style={{
                    padding: '10px',
                    border: '1px solid #dadbdc',
                    backgroundColor: '#efefef',
                  }}
                >
                  수강 기간 또는 컨텐츠 이용 1/10 경과 전
                </td>
                <td style={{ padding: '10px', border: '1px solid #dadbdc' }}> 결제대금의 9/10 </td>
                <td style={{ padding: '10px', border: '1px solid #dadbdc' }} rowSpan="8">
                  결제금액의 10%
                </td>
              </tr>
              <tr style={{ padding: '10px', border: '1px solid #dadbdc' }}>
                <td
                  style={{
                    padding: '10px',
                    border: '1px solid #dadbdc',
                    backgroundColor: '#efefef',
                  }}
                >
                  수강 기간 또는 컨텐츠 이용 2/10 경과 전
                </td>
                <td style={{ padding: '10px', border: '1px solid #dadbdc' }}> 결제대금의 8/10 </td>
              </tr>
              <tr style={{ padding: '10px', border: '1px solid #dadbdc' }}>
                <td
                  style={{
                    padding: '10px',
                    border: '1px solid #dadbdc',
                    backgroundColor: '#efefef',
                  }}
                >
                  수강 기간 또는 컨텐츠 이용 3/10 경과 전
                </td>
                <td style={{ padding: '10px', border: '1px solid #dadbdc' }}> 결제대금의 7/10 </td>
              </tr>
              <tr style={{ padding: '10px', border: '1px solid #dadbdc' }}>
                <td
                  style={{
                    padding: '10px',
                    border: '1px solid #dadbdc',
                    backgroundColor: '#efefef',
                  }}
                >
                  수강 기간 또는 컨텐츠 이용 4/10 경과 전
                </td>
                <td style={{ padding: '10px', border: '1px solid #dadbdc' }}> 결제대금의 6/10 </td>
              </tr>
              <tr style={{ padding: '10px', border: '1px solid #dadbdc' }}>
                <td
                  style={{
                    padding: '10px',
                    border: '1px solid #dadbdc',
                    backgroundColor: '#efefef',
                  }}
                >
                  수강 기간 또는 컨텐츠 이용 5/10 경과 전
                </td>
                <td style={{ padding: '10px', border: '1px solid #dadbdc' }}> 결제대금의 5/10 </td>
              </tr>
              <tr style={{ padding: '10px', border: '1px solid #dadbdc' }}>
                <td
                  style={{
                    padding: '10px',
                    border: '1px solid #dadbdc',
                    backgroundColor: '#efefef',
                  }}
                >
                  수강 기간 또는 컨텐츠 이용 6/10 경과 전
                </td>
                <td style={{ padding: '10px', border: '1px solid #dadbdc' }}> 결제대금의 4/10 </td>
              </tr>
              <tr style={{ padding: '10px', border: '1px solid #dadbdc' }}>
                <td
                  style={{
                    padding: '10px',
                    border: '1px solid #dadbdc',
                    backgroundColor: '#efefef',
                  }}
                >
                  수강 기간 또는 컨텐츠 이용 7/10 경과 전
                </td>
                <td style={{ padding: '10px', border: '1px solid #dadbdc' }}> 결제대금의 3/10 </td>
              </tr>
              <tr style={{ padding: '10px', border: '1px solid #dadbdc' }}>
                <td
                  style={{
                    padding: '10px',
                    border: '1px solid #dadbdc',
                    backgroundColor: '#efefef',
                  }}
                >
                  수강 기간 또는 컨텐츠 이용 8/10 경과 전
                </td>
                <td style={{ padding: '10px', border: '1px solid #dadbdc' }}> 결제대금의 2/10 </td>
              </tr>
              <tr style={{ padding: '10px', border: '1px solid #dadbdc' }}>
                <td
                  style={{
                    padding: '10px',
                    border: '1px solid #dadbdc',
                    backgroundColor: '#efefef',
                  }}
                >
                  수강 기간 또는 컨텐츠 이용 9/10 경과 후
                </td>
                <td style={{ padding: '10px', border: '1px solid #dadbdc' }}>환불 불가</td>
                <td style={{ padding: '10px', border: '1px solid #dadbdc' }}>-</td>
              </tr>
            </tbody>
          </table>

          <p style={{ padding: '40px 0 20px', fontSize: '20px' }}>준비물 환불 및 교환</p>

          <table>
            <colgroup>
              <col style={{ width: '20%' }} />
              <col style={{ width: '26.666666666666668%' }} />
              <col style={{ width: '26.666666666666668%' }} />
              <col style={{ width: '26.666666666666668%' }} />
            </colgroup>

            <tbody>
              <tr>
                <th>구분</th>
                <th>준비물 상품성 훼손 여부</th>
                <th>환불액</th>
                <th>교환 요청 가능 여부</th>
              </tr>
              <tr>
                <th>배송 완료로부터 7일 이내</th>
                <td>X</td>
                <td>결제 금액에서 왕복 택배비를 제한 금액</td>
                <td>가능</td>
              </tr>
              <tr>
                <th>배송 완료로부터 7일 이내</th>
                <td>O</td>
                <td>청약철회 제한</td>
                <td>불가</td>
              </tr>
              <tr>
                <th>배송 완료로부터 7일 초과</th>
                <td>-</td>
                <td>청약철회 제한</td>
                <td>불가</td>
              </tr>
            </tbody>
          </table>
          <OrderedList style={{ marginTop: '15px', listStyle: 'none' }}>
            <li style={{ marginBottom: '5px' }}>
              수강기간이란 회원이 구매한 수강권의 수강 기간을 의미합니다.
            </li>
            <li>
              수강기간은 결제일부터 시작하나, 결제일 당시 클래스가 개강되기 전이라면, 수강기간은
              클래스가 개강한 날로부터 시작합니다.
            </li>
            <li>
              컨텐츠 이용이란, 클래스를 구성하는 컨텐츠 중 이용한 컨텐츠의 비율을 의미합니다. 단,
              클래스 영상의 일부 재생 시 이용한 것으로 간주합니다.
            </li>
            <li>
              환불 요청일 기준 수강기간과 수강진도 중 높은 값을 적용하여 환불금액을 산정합니다.
            </li>
            <li>수업 자료를 다운받았을 경우에는 컨텐츠를 이용하신 것으로 간주합니다.</li>
            <li>
              사용하신 수강 기간은 클래스 시작일로부터 환불 접수일까지의 기간으로 계산합니다.
              <br />- 학습기간 별로 수강기간과 추가 혜택 기간이 존재합니다. 환불은 수강 기간에
              대하여만 진행되며, 추가 혜택 기간에는 환불이 불가합니다.
              <br />
              - 1개월권 구매 시 = 수강기간 (31일)
              <br />
              - 3개월권 구매 시 = 수강기간 (93일)
              <br />
              - 6개월권 구매 시 = 수강기간 (186일)
              <br />- 평생 수강권은 실 수강기간(6개월)에 추가 혜택기간이 포함된 것으로, 실 수강 기간
              종료 후 추가 혜택기간에 클래스의 변화에 관하여는 책임을 지지 않습니다.
            </li>
            <li>
              수강기간은 일시정지 하실 수 없으며, 구매하신 수강권(수강 기간)을 이용 중 변경하는 것은
              불가능합니다.
            </li>
            <li>포인트를 활용하여 결제하신 경우, 환불 시 사용하신 포인트는 반환되지 않습니다.</li>
            <li>
              준비물이 배송 준비중에 있을 때 취소 요청을 하신 경우, 배송 업체에 확인 후 환불절차가
              진행됩니다.
              <br />- 만일 배송이 이미 시작된 경우, 왕복배송비 차감 후 환불이 진행됩니다.
            </li>
            <li>
              사은품을 받고 취소를 하신 경우, 사은품은 준비물과 동일하게 보고 결제하신 금액에서 차감
              후 환불이 진행됩니다.
            </li>
            <li>준비물의 경우, 제조사의 환불 및 A/S 정책을 따릅니다.</li>
            <li>
              당일 카드 취소는 즉시 취소확인이 가능하나, 일정 기간이 지난 후 취소한 경우 일부
              카드수수료 등이 발생할 수 있으며, 승인 취소가 되기까지 영업일 기준 최대 5일 정도의
              기간이 소요됩니다.
            </li>
            <li>
              전액환불 대상이나, 카드 취소가 불가한 경우 계좌이체로 환불이 진행되며 결제 수수료 5%를
              제외하고 환불이 진행됩니다.
            </li>
            <li>
              <span style={{ color: palette.grey050 }}>
                * 환급반/ 환불보장 클래스의 경우 당사에서 진행하는 이벤트가 아닌 강사님께서 별도로
                진행하는 이벤트이므로, 당사에서 진행하는 환불규정과는 별개의 내용입니다. 해당 클래스
                환급 관련 문의는 강사님께 메세지 바랍니다.
              </span>
            </li>
          </OrderedList>

          <p style={{ padding: '40px 0 20px', fontSize: '20px' }}>
            <strong>환불 진행 방법</strong>
          </p>

          <OrderedList>
            <li>
              <strong>[스마트폰 이용시]</strong>
              <br />
              어플 우측 상단 [마이프로필] &gt; [내정보] &gt; [결제내역] 에서 환불 원하시는 클래스의
              [결제 상세 보기] 클릭 후 [환불 신청] 탭 클릭하여 환불 양식 작성하여 신청해주세요.
              <br />
            </li>
            <li>
              <strong>[PC 이용시]</strong>
              <br />
              {process.env.NEXT_PUBLIC_BRAND_KOR} 홈페이지 접속하여 우측 상단{' '}
              {process.env.NEXT_PUBLIC_BRAND_KOR} 아이콘 클릭 [내정보] &gt; [결제내역] 에서 환불
              원하시는 클래스의 [결제 상세 보기] 클릭 후 [환불 신청] 탭 클릭하여 환불 양식 작성하여
              신청해주세요.
            </li>
            <li>
              <span style={{ color: palette.red040 }}>환불 규정 필시 확인 바랍니다.</span>
              <br />
              <u>## 접수일 기준 48시간내 처리 됩니다.</u>
              <br />
              ☞환불 신청 전 고려하셔야 할 사항 안내드립니다.
              <br />
              1. 결제일로부터 7일 이전, 무료 강의 외 사용한 강의 없는 경우 적립금, 결제 금액 전액
              환불
              <br />
              2. 결제일로부터 7일 이전, 무료 강의 외 사용한 강의 있거나 결제일로부터 7일 이후 환불
              접수하시는 경우 이용분에 대해 차감 결제금액 10%수수료발생,적립금 환불 X
              <br />
              <u>
                * 사용일수는 클래스 시작일로부터 환불건 접수해주신 날짜까지를 기준으로 환불이
                진행됩니다.
              </u>
              <br />
              3. 준비물 환불은 클래스톡내 상담창을 통해 문의해주세요.
              <br />
              4. 환불기간
              <br />
              - 환불은 평일 09:00~17:00에 처리되며, 계좌이체건 환불은 월/수/금 오후 중으로
              처리됩니다.
              <br />
              - 처리 이후 문자 전송되며, 카드 취소의 경우 2~3일후 취소 문자 발송됩니다.
              <br />
              - (문자는 web발신 전용으로 수신이 어렵습니다.)
              <br />
            </li>
          </OrderedList>
        </>
      ),
    },
    {
      q: '결제(클래스)내역이 보이지 않아요',
      a: () => (
        <OrderedList style={{ listStyle: 'none' }}>
          결제하신 계정과 로그인하신 계정이 다른 경우 결제내역이 확인되지 않을 수 있습니다.
          <br />
          <br />
          현재 {process.env.NEXT_PUBLIC_BRAND_KOR} 로그인 방법은 소셜(네이버,카카오톡, 페이스북)과
          핸드폰번호 ID, Biz이메일 발급으로 되어 있습니다.
          <br />
          <br />
          다중으로 가입하실 경우, 하나의 계정으로 연동되지 않고 각각의 독립된 계정으로 생성됩니다.
          <br />
          그렇기에 결제하신 계정으로 로그인하셔야만 내역이 확인 되실거예요.
          <br />
          결제 시 카카오톡 알림톡과 문자를 통해 어떤 계정으로 결제하셨는지 안내를 드리고 있으니
          확인해 주시고, 확인이 되지 않는다면, 고객센터 1:1 문의에 말씀주시면 확인
          도와드리겠습니다😊
          <br />
        </OrderedList>
      ),
    },
    {
      q: '결제내역은 어디에서 볼 수 있나요?',
      a: () => (
        <OrderedList style={{ listStyle: 'none' }}>
          클래스유 앱 또는 웹 우측 상단 <strong>'마이프로필 &gt; 내정보 &gt; 결제내역'</strong> 에서
          확인해보실 수 있습니다!
          <br />
          <br />
          결제내역이 확인되지 않으신 경우는, 결제하신 계정과 로그인한 계정이 상이하여 발생할 수 있는
          문제로, 로그아웃 후 결제하신 계정으로 접속하여 확인해주세요!
          <br />
          결제 시 카카오톡 알림톡과 문자를 통해 어떤 계정으로 결제하셨는지 안내를 드리고 있으니
          확인해 주시고, 확인이 되지 않는다면, 고객센터 1:1 문의에 말씀주시면 확인
          도와드리겠습니다😊
        </OrderedList>
      ),
    },
    {
      q: '지급받은 적립금은 어떻게 사용하나요? / 내 적립금은 어디서 확인 가능한가요?',
      a: () => (
        <OrderedList style={{ listStyle: 'none' }}>
          왕성한 활동으로 포인트를 열심히 모아주셨군요. 감사합니다.
          <br />
          획득하신 포인트는 <strong>'마이프로필 &gt; 내정보 &gt; 적립금(원)'</strong>에서
          적립/사용/소멸 내역 및 유효기간 확인 가능하며, 포인트는 '클래스유' 내에서만 사용이
          가능합니다.
          <br />
          <br />
          원하는 클래스를 골라 결제를 진행하시면 내가 획득한 포인트를 적용하여 할인된 가격에
          결제하실 수 있습니다.
          <br />
          지금 바로 원하는 클래스를 골라 진행해 보세요.
          <br />
          <br />
          단, 준비물은 적립금을 사용하여 구매가 불가합니다.
          <br />
          <br />
          (*적립금은 결제금액의 최대 60%까지 사용이 가능합니다.)
          <br />
          (*초대 링크로 접속하신 경우라면 적립금 사용이 제한될 수 있습니다)
        </OrderedList>
      ),
    },
  ],
  user: [
    {
      q: '비밀번호를 잊어버렸어요.',
      a: () => (
        <OrderedList style={{ listStyle: 'none' }}>
          소셜 계정으로 로그인하신 경우, 해당 소셜에서 비밀번호 찾기를 진행해주세요.
          <br />
          핸드폰 번호로 로그인하신 경우, [로그인] - [비밀번호 찾기]를 클릭하신 후 핸드폰 번호를
          입력해주시면 카톡메시지로 재설정 링크를 발송해드립니다
          <br />
        </OrderedList>
      ),
    },
    {
      q: '탈퇴는 어떻게 하나요?',
      a: () => (
        <OrderedList style={{ listStyle: 'none' }}>
          클래스를 이용하시다 불편한 점이 있으셨을까요?
          <br />
          불편한 점이 있으셨다면 언제든 고객센터 1:1메세지로 남겨주세요!
          <br />
          더욱 개선하는 {process.env.NEXT_PUBLIC_BRAND_KOR}가 되겠습니다!
          <br />
          <br />
          탈퇴는 앱 또는 웹 우측 상단{' '}
          <u>'마이프로필 &gt; 내정보 &gt; 프로필관리' 하단의 [탈퇴하기]탭</u>을 눌러 진행하실 수
          있습니다.
          <br />
          <br />
          탈퇴시 복구가 어려우며, 24시간동안 재가입이 불가하오니 참고 부탁드립니다.
          <br />
        </OrderedList>
      ),
    },
    {
      q: '수강 신청한 계정이 기억나지 않아요!',
      a: () => (
        <OrderedList style={{ listStyle: 'none' }}>
          다중으로 가입하실 경우, 하나의 계정으로 연동되지 않고 각각의 독립된 계정으로 생성됩니다.
          <br />
          그렇기에 결제하신 계정으로 로그인하셔야만 내역이 확인 되실거예요.
          <br />
          <br />
          결제 시 카카오톡 알림톡과 문자를 통해 어떤 계정으로 결제하셨는지 안내를 드리고 있으니
          확인해 주시고,
          <br />
          확인이 되지 않는다면, 고객센터 1:1 문의에 말씀주시면 확인 도와드리겠습니다😊
        </OrderedList>
      ),
    },
  ],
};

/** FAQ 페이지 */
const FaqPage = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const { MetaTitle } = useMetaData();

  const onClickTab = index => setTabIndex(index);

  return (
    <OrderedList style={{ listStyle: 'none', paddingLeft: 0 }}>
      <MetaTitle content="FAQ" />

      <Wrapper>
        <VerticalScrollLayout>
          <Title>FAQ</Title>
          <TabWrapper>
            <TabButton
              selected={tabIndex === 0}
              size="Large"
              color={palette.grey040}
              onClick={() => onClickTab(0)}
            >
              이용안내
            </TabButton>
            <TabButton
              selected={tabIndex === 1}
              size="Large"
              color={palette.grey040}
              onClick={() => onClickTab(1)}
            >
              결제
            </TabButton>
            <TabButton
              selected={tabIndex === 2}
              size="Large"
              color={palette.grey040}
              onClick={() => onClickTab(2)}
            >
              회원정보
            </TabButton>
          </TabWrapper>

          {tabIndex === 0 && <InformationFAQ />}
          {tabIndex === 1 && <PaymentFAQ />}
          {tabIndex === 2 && <UserFAQ />}
        </VerticalScrollLayout>
      </Wrapper>
    </OrderedList>
  );
};

/** FAQ 리스트 만들어주는 함수 */
const FaqItem = ({ faq }) => {
  const [isOpen, setisOpen] = useState(false);

  const onClick = e => {
    const content = e.target.nextSibling;

    if (isOpen) {
      content.style.display = '';
    } else {
      content.style.display = 'block';
    }

    setisOpen(v => !v);
  };

  return (
    <OrderedList style={{ listStyle: 'none', paddingLeft: 0 }}>
      <DropdownItem color={palette.grey010} size="Large" onClick={onClick} selected={isOpen}>
        <span>
          <strong>Q.</strong>
          {faq.q}
        </span>
        <Icon name="ic_arrow_down_r" width={24} height={24} fill={palette.grey080} />
      </DropdownItem>
      <DropdownContent selected={isOpen}>{<faq.a />}</DropdownContent>
    </OrderedList>
  );
};

/** 이용안내 FAQ */
const InformationFAQ = () => {
  return (
    <div>
      {faq.information.map((v, idx) => (
        <FaqItem faq={v} key={idx} />
      ))}
    </div>
  );
};

/** 결제 FAQ */
const PaymentFAQ = () => {
  return (
    <div>
      {faq.payment.map((v, idx) => (
        <FaqItem faq={v} key={idx} />
      ))}
    </div>
  );
};

/** 회원정보 FAQ */
const UserFAQ = () => {
  return (
    <div>
      {faq.user.map((v, idx) => (
        <FaqItem faq={v} key={idx} />
      ))}
    </div>
  );
};

const Header = () => {
  const router = useRouter();

  const { onCloseWebView } = useCommonBridge();

  const onBack = () => {
    if (!onCloseWebView()) {
      router.back();
    }
  };

  return (
    <BothHeader
      message={`자주 묻는 질문`}
      leftSide={
        <IconButton width={24} height={54} onClick={onBack}>
          <Icon
            name="ic_back_m"
            width={24}
            height={24}
            fill={palette.grey75}
            stroke={palette.grey75}
          />
        </IconButton>
      }
    />
  );
};

FaqPage.getLayout = function getLayout(page) {
  return <Layout mobileHeader={<Header />}>{page}</Layout>;
};

const Wrapper = styled(MainLayout)`
  width: 1800px;
  padding: 24px 16px;

  ${mediaQuery.large} {
    padding: 48px 72px 64px;
  }
`;

const Title = styled.h1`
  border-bottom: 1px solid ${palette.system.BNB};
  padding-bottom: 8px;
  margin-bottom: 16px;
  ${typography.h1_medium};
  font-size: 24px;
  color: ${palette.grey75};
  ${mediaQuery.large} {
    font-size: 32px;
    border-bottom: 1px solid ${palette.system.grey};
  }
`;

const TabWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;

  ${mediaQuery.large} {
    justify-content: flex-start;
  }
`;

const TabButton = styled(OutlineButton)`
  height: 40px;
  background-color: ${({ selected }) => (selected ? palette.grey0 : palette.BTN.BG)};
  border: none;
  color: ${({ selected }) => (selected ? palette.grey75 : palette.grey50)};
  font-size: 14px;

  & ~ & {
    margin-left: 8px;
  }

  ${mediaQuery.large} {
    height: 48px;

    & ~ & {
      margin-left: 16px;
    }
  }
`;

const DropdownItem = styled(FillButton)`
  width: 100%;
  padding: 8px 16px;
  justify-content: space-between;
  background-color: ${({ selected }) => (selected ? palette.grey0 : palette.BTN.BG)};
  color: ${({ selected }) => (selected ? palette.grey75 : palette.grey50)};
  font-size: 12px;
  cursor: pointer;

  & strong {
    padding-right: 12px;
  }

  & svg {
    fill: ${({ selected }) => (selected ? palette.grey75 : palette.grey50)};
    transform: ${({ selected }) => (selected ? `rotate(180deg)` : `rotate(0)`)};
    transform-origin: center;
  }

  ${mediaQuery.large} {
    padding: 12px 20px;
    font-size: 14px;
  }

  & ~ & {
    margin-top: 8px;
  }
`;

const DropdownContent = styled.div`
  display: none;
  padding: 24px 16px;
  ${typography.body3_regular};
  transition: 0.3s ease;
  overflow: hidden;
  background-color: transparent !important;

  * {
    color: ${palette.grey25};
  }
  table {
    width: 100%;
    border: 1px solid;
    border-color: ${palette.black};
    margin: 4px 0;
    text-align: center;
    font-size: 12px;
    background-color: transparent !important;
    caption {
      display: none;
    }

    th,
    td {
      padding: 10px 4px;
      border: 1px solid;
      border-color: ${palette.system.grey} !important;
      background-color: transparent !important;
    }

    tr {
      background-color: transparent !important;
    }
  }
`;

const OrderedList = styled.ul`
  padding-left: 20px;
  counter-reset: detail-counter;

  li {
    line-height: 2;
  }

  li::before {
    display: inline-block;
    width: 20px;
    counter-increment: detail-counter;
    content: '(' counter(detail-counter) ')';
    margin-left: -24px;
    margin-right: 4px;
  }
`;

export default FaqPage;
